/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Update SKU when variant changes
  document.addEventListener('DOMContentLoaded', function() {
    // Listen for variant change events
    document.addEventListener('theme:variant:change', function(event) {
      var variant = event.detail.variant;
      var skuWrapper = document.querySelector('[data-sku-wrapper]');
      var skuElement = document.querySelector('[data-variant-sku]');
      
      if (skuElement && variant) {
        if (variant.sku && variant.sku !== '') {
          skuElement.textContent = variant.sku;
          if (skuWrapper) {
            skuWrapper.style.display = 'block';
          }
        } else {
          if (skuWrapper) {
            skuWrapper.style.display = 'none';
          }
        }
      }
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
